import { render, staticRenderFns } from "./packsDetails.vue?vue&type=template&id=2258a060&scoped=true&"
import script from "./packsDetails.vue?vue&type=script&lang=js&"
export * from "./packsDetails.vue?vue&type=script&lang=js&"
import style0 from "./packsDetails.vue?vue&type=style&index=0&id=2258a060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258a060",
  null
  
)

export default component.exports